module.exports = __webpack_public_path__ + "static/media/logo_mural.48797e72.png";